import 'app.css'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Home from 'pages/home'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useAxiosInterceptorsResponse } from 'service/hooks/useAxiosInterceptorsResponse'

const queryClient = new QueryClient()

function App() {
  useAxiosInterceptorsResponse()

  return (
    <div className='font-sans'>
      <QueryClientProvider client={queryClient}>
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_LOGIN_CLIENT_ID as string}>
          <BrowserRouter>
            <Routes>
              <Route key='/' path='/' element={<Home />} />
            </Routes>
          </BrowserRouter>
        </GoogleOAuthProvider>
      </QueryClientProvider>
    </div>
  )
}

export default App
